import apiClient from './client'

export interface BiodataItem {
  id: number
  person_id: number
  bio_data_title?: string
  bio_data?: string
  bio_data_date?: string
  update_date?: string
}

export interface PaginatedBiodata {
  items: BiodataItem[]
  total: number
  page: number
  size: number
  pages: number
  has_next: boolean
  has_prev: boolean
}

export const biodataApi = {
  listByPerson: async (
    personId: number,
    page = 1,
    size = 20
  ): Promise<PaginatedBiodata> => {
    const { data } = await apiClient.get('/biodata/', { params: { person_id: personId, page, size } })
    return data
  },

  get: async (id: number): Promise<BiodataItem> => {
    const { data } = await apiClient.get(`/biodata/${id}`)
    return data
  },

  create: async (
    personId: number,
    payload: { bio_data_title?: string; bio_data?: string; bio_data_date?: string }
  ): Promise<{ message: string; success: boolean; data: { id: number; person_id: number } }> => {
    const { data } = await apiClient.post('/biodata/', { person_id: personId, ...payload })
    return data
  },

  update: async (
    id: number,
    payload: { bio_data_title?: string; bio_data?: string; bio_data_date?: string }
  ): Promise<{ message: string; success: boolean }> => {
    const { data } = await apiClient.put(`/biodata/${id}`, payload)
    return data
  },

  remove: async (id: number): Promise<{ message: string; success: boolean }> => {
    const { data } = await apiClient.delete(`/biodata/${id}`)
    return data
  },
}


